import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
	selector: 'app-quotes-table-skeleton',
	imports: [CommonModule],
	templateUrl: './quotes-table-skeleton.component.html',
	styleUrl: './quotes-table-skeleton.component.scss',
})
export class QuotesTableSkeletonComponent {
	showProducer = input<boolean>(true);

	showUser = input<boolean>(true);
}
